module.exports = __webpack_public_path__ + "img/home_coupon_bg_icon.33f8e468.png";